import { render, staticRenderFns } from "./message-center.vue?vue&type=template&id=4ba99734&"
import script from "./message-center.ts?vue&type=script&lang=ts&"
export * from "./message-center.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports